import AlertInlineMessage from '@components/ui/AlertInlineMessage';
import { InlineAlertSliceData } from '@adapters/prismic/types/slices';
import MarkdownCopy from '../MarkdownCopy';

import styles from './InlineAlert.module.scss';

const InlineAlert = ({
  text,
  messageType = 'INFORMATION',
}: InlineAlertSliceData) => (
  <AlertInlineMessage messageType={messageType}>
    <MarkdownCopy text={text} className={styles.removeMargin} />
  </AlertInlineMessage>
);

export default InlineAlert;
